import React, { useState, useCallback, useRef } from 'react';
import './index.css';

export const EventTriggeredSentimentsPopUp = () => {
  const [timerStarted, setTimerStarted] = useState(false);
  const [scrollStarted, setScrollStarted] = useState(false);
  const intervalTimer = useRef(null);

  const triggerSentiment = useCallback(() => {
    window.wogaaCustom.sentiments.showRatingPopup();
  }, []);

  const handleScrollToBottom = useCallback(() => {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 1) {
      triggerSentiment();
    }
  }, []);

  const handleTimerOnClick = useCallback(() => {
    if (timerStarted) {
      clearInterval(intervalTimer.current);
    } else {
      intervalTimer.current = setInterval(triggerSentiment, 5000);
    }
    setTimerStarted((prev) => !prev);
  }, [timerStarted]);

  const handleScrollOnClick = useCallback(() => {
    if (scrollStarted) {
      window.removeEventListener('scroll', handleScrollToBottom);
    } else {
      window.addEventListener('scroll', handleScrollToBottom);
    }
    setScrollStarted((prev) => !prev);
  }, [scrollStarted]);

  return (
    <>
      <div className="content">
        <h1>Examples of Event Triggered Sentiments</h1>
        <div className="example">
          <u>
            <h5>Trigger on click Event</h5>
          </u>
          <button className="example-button" onClick={triggerSentiment}>
            trigger
          </button>
        </div>
        <div className="example">
          <u>
            <h5>Trigger on scroll Event</h5>
          </u>
          <p>After start, try to scroll to bottom of the page</p>
          <button className="example-button" onClick={handleScrollOnClick}>
            scroll {scrollStarted ? 'stop' : 'start'}
          </button>
        </div>
        <div className="example">
          <u>
            <h5>Trigger at Regular Intervals Using setInterval</h5>
          </u>
          <p>After start, the sentiment will pop-up every 5 seconds</p>
          <button className="example-button" onClick={handleTimerOnClick}>
            timer {timerStarted ? 'stop' : 'start'}
          </button>
        </div>
      </div>
      <div className="footer">Footer</div>
    </>
  );
};
